import React, { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

interface UnderlineLinkProps extends BoxProps {
  href?: string;
}

export const UnderlineLink: FC<UnderlineLinkProps> = (props) => (
  <Box
    as='a'
    pos='relative'
    href='#'
    display='inline-block'
    transition='opacity 0.2s'
    _hover={{ opacity: 0.8 }}
    _after={{
      content: '""',
      display: 'block',
      w: 'full',
      h: '2px',
      bottom: 0,
      bg: 'brand.500',
      insetX: 0,
      insetY: 0
    }}
    {...props}
  />
);
